import {Injectable} from '@angular/core';
import {WaToastService} from "angular-awesome";

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor(private toastService: WaToastService) {}

  log(msg: string): void {
    console.log(msg);
  }

  showSimple(msg: string, action: string | undefined = undefined) {
    const ref = this.toastService.show(msg + action);
  }
}
